import type { Competition } from '@/lib/api/competitionsApi';
import { Copy, Mail } from 'lucide-react';
import { toast } from 'sonner';

import { Facebook, Linkedin, Twitter } from '../ui/social-icons';

export default function ShareBloc({ competition }: { competition: Competition }) {
  if (!competition) return null;
  const shareUrl = encodeURIComponent(window.location.href);
  const shareText = encodeURIComponent(`${competition.name} — ${competition.venue ?? competition.city ?? ''}`);
  const socials = [
    {
      icon: Facebook,
      color: 'bg-blue-100 text-blue-600 hover:bg-blue-200',
      href: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareText}`,
    },
    {
      icon: Linkedin,
      color: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
    },
    {
      icon: Twitter,
      color: 'bg-sky-100 text-sky-600 hover:bg-sky-200',
      href: `https://x.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
    },
    {
      icon: Mail,
      color: 'bg-slate-100 text-slate-600 hover:bg-slate-200',
      href: `mailto:?subject=${shareText}&body=${shareUrl}`,
    },
  ];
  return (
    <div id={'shareButtons'} className='bg-white rounded-3xl border border-slate-200 p-6'>
      <h3 className='font-bold text-lg text-slate-900 mb-4'>Partager ce concours</h3>
      <div className='flex items-center gap-3'>
        {socials.map((s, i) => (
          <a
            key={i}
            href={s.href}
            target='_blank'
            rel='noopener noreferrer'
            className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${s.color}`}
          >
            <s.icon className='w-5 h-5' />
          </a>
        ))}
        <button
          onClick={() => {
            void navigator.clipboard.writeText(window.location.href);
            toast.success('Lien copié !');
          }}
          className='w-12 h-12 rounded-xl flex items-center justify-center transition-colors bg-slate-100 text-slate-600 hover:bg-slate-200'
        >
          <Copy className='w-5 h-5' />
        </button>
      </div>
    </div>
  );
}
